/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleLetterI = createReactComponent("circle-letter-i", "IconCircleLetterI", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 8v8", key: "svg-1" }]
]);

export { IconCircleLetterI as default };
//# sourceMappingURL=IconCircleLetterI.js.map
